import type { SvgIconProps } from './types';

export function PaystackLogo(props: SvgIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="110px" height="28px" viewBox="0 0 120 30" {...props}>
                                            <path fill="#0BA4DB" d="M15 2H3a3 3 0 0 0-3 3v20a3 3 0 0 0 3 3h12v-5H6v-3h8v-5H6v-3h9z"></path>
                                            <text x="28" y="21" fontSize="14" fontFamily="Arial, sans-serif" fontWeight="700" fill="#0A2540">
                                                paystack
                                            </text>
                                        </svg>
  );
}
